import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// ============== Match History API ==============

export const matchAPI = {
  // Save a completed match
  saveMatch: async (matchData) => {
    try {
      const response = await apiClient.post('/matches', matchData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to save match:', error);
      return { success: false, error: error.message };
    }
  },

  // Get match history with pagination
  getMatches: async (limit = 50, skip = 0) => {
    try {
      const response = await apiClient.get('/matches', {
        params: { limit, skip }
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to get matches:', error);
      return { success: false, error: error.message, data: { matches: [], total: 0 } };
    }
  },

  // Get a specific match
  getMatch: async (matchId) => {
    try {
      const response = await apiClient.get(`/matches/${matchId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to get match:', error);
      return { success: false, error: error.message };
    }
  },

  // Delete a match
  deleteMatch: async (matchId) => {
    try {
      const response = await apiClient.delete(`/matches/${matchId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to delete match:', error);
      return { success: false, error: error.message };
    }
  },

  // Get game statistics
  getStats: async () => {
    try {
      const response = await apiClient.get('/stats');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to get stats:', error);
      return { success: false, error: error.message, data: { total_matches: 0, pvp_matches: 0, pvc_matches: 0, highest_score: 0 } };
    }
  }
};

// ============== Invite API ==============

export const inviteAPI = {
  // Create an invite
  createInvite: async (inviterName, message = null) => {
    try {
      const response = await apiClient.post('/invites', {
        inviter_name: inviterName,
        message
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create invite:', error);
      return { success: false, error: error.message };
    }
  },

  // Get invite details
  getInvite: async (inviteId) => {
    try {
      const response = await apiClient.get(`/invites/${inviteId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to get invite:', error);
      return { success: false, error: error.message };
    }
  },

  // Generate share URL
  getShareUrl: (inviteId) => {
    return `${window.location.origin}/?invite=${inviteId}`;
  }
};

// ============== Health Check API ==============

export const healthAPI = {
  check: async () => {
    try {
      const response = await apiClient.get('/health');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Health check failed:', error);
      return { success: false, error: error.message };
    }
  }
};

export default apiClient;
